import { render, staticRenderFns } from "./PercentageChart.vue?vue&type=template&id=b3e246fa&scoped=true&"
import script from "./PercentageChart.vue?vue&type=script&lang=js&"
export * from "./PercentageChart.vue?vue&type=script&lang=js&"
import style0 from "./PercentageChart.vue?vue&type=style&index=0&id=b3e246fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e246fa",
  null
  
)

export default component.exports